import React, { useState } from 'react';

import AthleteCreditsFilter from './components/AthleteCreditsFilter';
import AthleteCreditsTableContainer from './components/AthleteCreditsTableContainer';

interface ICreditsProps {
  athleteId: string | undefined;
}

const Credits = ({ athleteId }: ICreditsProps): JSX.Element => {
  const [validityDate, setValidityDate] = useState<Date>(new Date());
  return (
    <>
      <AthleteCreditsFilter validityDate={validityDate} setValidityDate={setValidityDate} />
      <AthleteCreditsTableContainer athleteId={athleteId} validityDate={validityDate} />
    </>
  );
};

export default Credits;
